import { render } from "./YearMaster.vue?vue&type=template&id=12410ced&scoped=true"
import script from "./YearMaster.vue?vue&type=script&lang=js"
export * from "./YearMaster.vue?vue&type=script&lang=js"

import "./YearMaster.vue?vue&type=style&index=0&id=12410ced&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\CMRF\\cmrf_admin_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12410ced"]])

export default __exports__